module.exports = __webpack_public_path__ + "img/arrow-up-down.cb77f56d.svg";